
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kmSGd", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");


var $ieeJu = parcelRequire("ieeJu");


var $1LXnB = parcelRequire("1LXnB");


var $hjUDQ = parcelRequire("hjUDQ");

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $hekY6 = parcelRequire("hekY6");


var $bIp5p = parcelRequire("bIp5p");

const $d9744d68c931f1dc$var$ItemSelectedToEditWrapperStyles = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isSelectedToEdit: isSelectedToEdit, isSelectedToRemove: isSelectedToRemove, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "",
            __cmplp.isSelectedToEdit && "_3CAujFXzJH",
            __cmplp.isSelectedToRemove && "_3CAujFOvEe",
            __cmplp.isSelectedToRemove && "_0yOKj6ogpp _2ky4raWVPG _2esDQsdnbC _3hyFsGdnbC _1FC8WudnbC _2AFecfdnbC _448ViF7dHp _36mWNqXvJ3 _3M1vsMhH7k",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelectedToEdit: isSelectedToEdit, isSelectedToRemove: isSelectedToRemove, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.isSelectedToEdit && "_3CAujFXzJH",
            __cmplp.isSelectedToRemove && "_3CAujFOvEe",
            __cmplp.isSelectedToRemove && "_0yOKj6ogpp _2ky4raWVPG _2esDQsdnbC _3hyFsGdnbC _1FC8WudnbC _2AFecfdnbC _448ViF7dHp _36mWNqXvJ3 _3M1vsMhH7k",
            __cmplp.className
        ])
    });
});
const $d9744d68c931f1dc$export$d3fc0aff4df25c77 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { extensionLocalId: extensionLocalId, itemId: itemId, children: children } = t0;
    const itemRef = (0, $cozmU.useRef)(null);
    const [t1, t2] = (0, $bIp5p.useExtensionsState)();
    const { selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId } = t1;
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = t2;
    let t3;
    if ($[0] !== extensionLocalId || $[1] !== itemId || $[2] !== selectedExtensionLocalId || $[3] !== setIsInAutoFocusMode || $[4] !== setSelectedToEditCardId) {
        t3 = ()=>{
            if (extensionLocalId === selectedExtensionLocalId) {
                setIsInAutoFocusMode(true);
                setSelectedToEditCardId(itemId);
            }
        };
        $[0] = extensionLocalId;
        $[1] = itemId;
        $[2] = selectedExtensionLocalId;
        $[3] = setIsInAutoFocusMode;
        $[4] = setSelectedToEditCardId;
        $[5] = t3;
    } else t3 = $[5];
    const onItemClick = t3;
    const isSelectedToEdit = selectedToEditCardId === itemId && extensionLocalId === selectedExtensionLocalId;
    const isSelectedToRemove = selectedToRemoveCardId === itemId && extensionLocalId === selectedExtensionLocalId;
    let t4;
    if ($[6] !== children || $[7] !== isSelectedToEdit || $[8] !== isSelectedToRemove || $[9] !== onItemClick) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9744d68c931f1dc$var$ItemSelectedToEditWrapperStyles, {
            ref: itemRef,
            isSelectedToEdit: isSelectedToEdit,
            isSelectedToRemove: isSelectedToRemove,
            onClick: onItemClick
        }, children);
        $[6] = children;
        $[7] = isSelectedToEdit;
        $[8] = isSelectedToRemove;
        $[9] = onItemClick;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ extensionLocalId: extensionLocalId, itemId: itemId, children: children })=>{
    const itemRef = (0, $cozmU.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $bIp5p.useExtensionsState)();
    const onItemClick = (0, $cozmU.useCallback)(()=>{
        if (extensionLocalId === selectedExtensionLocalId) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(itemId);
        }
    }, [
        itemId,
        extensionLocalId,
        selectedExtensionLocalId,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const isSelectedToEdit = selectedToEditCardId === itemId && extensionLocalId === selectedExtensionLocalId;
    const isSelectedToRemove = selectedToRemoveCardId === itemId && extensionLocalId === selectedExtensionLocalId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9744d68c931f1dc$var$ItemSelectedToEditWrapperStyles, {
        ref: itemRef,
        isSelectedToEdit: isSelectedToEdit,
        isSelectedToRemove: isSelectedToRemove,
        onClick: onItemClick
    }, children);
};




var $cfM7x = parcelRequire("cfM7x");


var $4WDWC = parcelRequire("4WDWC");


var $4pBmf = parcelRequire("4pBmf");


var $aOuIh = parcelRequire("aOuIh");


var $eafQX = parcelRequire("eafQX");


var $gXR7h = parcelRequire("gXR7h");


var $4MaGu = parcelRequire("4MaGu");














var $kSwu1 = parcelRequire("kSwu1");


var $9ECRl = parcelRequire("9ECRl");




















var $kmQhR = parcelRequire("kmQhR");





var $1sCHt = parcelRequire("1sCHt");





var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");


var $k5vii = parcelRequire("k5vii");


var $fZ6J4 = parcelRequire("fZ6J4");




var $1l0kj = parcelRequire("1l0kj");


var $lb2UL = parcelRequire("lb2UL");





var $5D0gt = parcelRequire("5D0gt");

var $531JC = parcelRequire("531JC");

var $gMXXV = parcelRequire("gMXXV");










const $b5e25217b125fc4a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    previousSlide: {
        id: "company-hub.carousel-extension.carousel-navigation.row-orientation.previous-slide",
        defaultMessage: "Previous slide"
    },
    nextSlide: {
        id: "company-hub.carousel-extension.carousel-navigation.row-orientation.next-slide",
        defaultMessage: "Next slide"
    },
    playAutoRotation: {
        id: "company-hub.carousel-extension.carousel-navigation.start-auto-rotation",
        defaultMessage: "Start auto-rotation"
    },
    pauseAutoRotation: {
        id: "company-hub.carousel-extension.carousel-navigation.pause-auto-rotation",
        defaultMessage: "Pause auto-rotation"
    },
    slide: {
        id: "company-hub.carousel-extension.carousel-navigation.slide-label",
        defaultMessage: "Slide {positionInSet} of {setSize}"
    }
});


const $8f889889666a75e0$var$NAVIGATION_PADDING_BREAKPOINT_WIDTH = 800;
const $8f889889666a75e0$var$styles = {
    navigationContainer: "_39xV02N91d _1EqgXlN91d",
    navigationContainerWithPadding: "_2Y7lL45zaO",
    thumbnailNavigationContainer: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNOdnbC _1bHrqEAEMG _3iDTPbQ4SZ _1mT5xdRAKS _2Zuz6QPgdg",
    left: "_37wbyuchRC",
    center: "_37wbyuDIqT",
    right: "_37wbyuz9WS",
    progressContainer: "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEAEMG",
    progressPadding: "_2Zuz6QNHnM",
    iconBackgroundColor: "_0bjKvDS5Zs _0KLXrulfZc"
};
const $8f889889666a75e0$export$bb2ef5dc2942d541 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(77);
    const { extensionLocalId: extensionLocalId, frames: frames, frameIds: frameIds, selectedHeroFrameIndex: selectedHeroFrameIndex, isHovered: isHovered, isCarouselVisible: isCarouselVisible, isAutoplayEnabled: isAutoplayEnabled, navigationStyle: navigationStyle, renderFrame: renderFrame, handleNavigationFrameUpdate: handleNavigationFrameUpdate, width: t1 } = t0;
    const width = t1 === undefined ? 0 : t1;
    const intl = (0, $kSwu1.useIntl)();
    const isThumbnailNavigation = navigationStyle === (0, $4MaGu.NavigationStyle).THUMBNAILS;
    const [isAutoPlaying, setIsAutoPlaying] = (0, $cozmU.useState)(isAutoplayEnabled);
    const intervalRef = (0, $cozmU.useRef)(null);
    const frameSize = (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL_V2];
    let t2;
    if ($[0] !== frames.length) {
        t2 = {
            numberOfCards: frames.length,
            cardDimensions: (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL_V2]
        };
        $[0] = frames.length;
        $[1] = t2;
    } else t2 = $[1];
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth, setCurrentCardWidth: setCurrentCardWidth } = (0, $gMXXV.useWidthAndSpacingCalculations)(t2);
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowFull: isFirstRowFull, gaps: gaps, maxNumberOfCardsPerRow: maxNumberOfCardsPerRow, isFirstRowOverflown: isFirstRowOverflown } = calculations;
    let t3;
    if ($[2] !== setCurrentCardsGridWidth) {
        t3 = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(setCurrentCardsGridWidth, 200);
        $[2] = setCurrentCardsGridWidth;
        $[3] = t3;
    } else t3 = $[3];
    const throttledSetWidth = t3;
    const spaceBetweenFrames = gaps.spaceBetweenCards;
    const t4 = frames?.length;
    let t5;
    if ($[4] !== maxNumberOfCardsPerRow || $[5] !== t4) {
        t5 = {
            maxNumberOfItemsPerRow: maxNumberOfCardsPerRow,
            numberOfItems: t4,
            isRow: true
        };
        $[4] = maxNumberOfCardsPerRow;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const { scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext, scrollToIndex: scrollToIndex, requestScrollIndex: requestScrollIndex, resetScrollIndex: resetScrollIndex } = (0, $531JC.useOrientationScrolling)(t5);
    let t6;
    if ($[7] !== frames.length || $[8] !== handleNavigationFrameUpdate || $[9] !== requestScrollIndex || $[10] !== scrollToNext || $[11] !== selectedHeroFrameIndex) {
        t6 = ()=>{
            if (selectedHeroFrameIndex < frames.length - 1) {
                handleNavigationFrameUpdate(selectedHeroFrameIndex + 1);
                scrollToNext();
            } else {
                requestScrollIndex(0);
                handleNavigationFrameUpdate(0);
            }
        };
        $[7] = frames.length;
        $[8] = handleNavigationFrameUpdate;
        $[9] = requestScrollIndex;
        $[10] = scrollToNext;
        $[11] = selectedHeroFrameIndex;
        $[12] = t6;
    } else t6 = $[12];
    const handleNextClick = t6;
    let t7;
    if ($[13] !== frames.length || $[14] !== handleNavigationFrameUpdate || $[15] !== requestScrollIndex || $[16] !== scrollToPrevious || $[17] !== selectedHeroFrameIndex) {
        t7 = ()=>{
            if (selectedHeroFrameIndex > 0) {
                scrollToPrevious();
                handleNavigationFrameUpdate(selectedHeroFrameIndex - 1);
            } else {
                const lastFrameIndex = frames.length - 1;
                requestScrollIndex(lastFrameIndex);
                handleNavigationFrameUpdate(lastFrameIndex);
            }
        };
        $[13] = frames.length;
        $[14] = handleNavigationFrameUpdate;
        $[15] = requestScrollIndex;
        $[16] = scrollToPrevious;
        $[17] = selectedHeroFrameIndex;
        $[18] = t7;
    } else t7 = $[18];
    const handlePreviousClick = t7;
    let t8;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            setIsAutoPlaying($8f889889666a75e0$var$_temp);
        };
        $[19] = t8;
    } else t8 = $[19];
    const handlePausePlayClick = t8;
    let t9;
    if ($[20] !== handleNavigationFrameUpdate) {
        t9 = (t10)=>{
            const { index: selectedIndex } = t10;
            handleNavigationFrameUpdate(selectedIndex);
        };
        $[20] = handleNavigationFrameUpdate;
        $[21] = t9;
    } else t9 = $[21];
    const handleSelect = t9;
    let t10;
    if ($[22] !== handleNextClick || $[23] !== isAutoPlaying || $[24] !== isCarouselVisible || $[25] !== isHovered) {
        t10 = ()=>{
            if (isAutoPlaying && !isHovered) intervalRef.current = setInterval(()=>{
                if (isCarouselVisible()) handleNextClick();
            }, (0, $gXR7h.AUTOPLAY_SECONDS) * 1000);
            return ()=>{
                if (intervalRef.current) clearInterval(intervalRef.current);
            };
        };
        $[22] = handleNextClick;
        $[23] = isAutoPlaying;
        $[24] = isCarouselVisible;
        $[25] = isHovered;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== handleNextClick || $[28] !== isAutoPlaying || $[29] !== isCarouselVisible || $[30] !== isHovered || $[31] !== selectedHeroFrameIndex) {
        t11 = [
            isAutoPlaying,
            isCarouselVisible,
            isHovered,
            selectedHeroFrameIndex,
            handleNextClick
        ];
        $[27] = handleNextClick;
        $[28] = isAutoPlaying;
        $[29] = isCarouselVisible;
        $[30] = isHovered;
        $[31] = selectedHeroFrameIndex;
        $[32] = t11;
    } else t11 = $[32];
    (0, $cozmU.useEffect)(t10, t11);
    const t12 = width > $8f889889666a75e0$var$NAVIGATION_PADDING_BREAKPOINT_WIDTH && $8f889889666a75e0$var$styles.navigationContainerWithPadding;
    let t13;
    if ($[33] !== t12) {
        t13 = (0, $w6R6I.cx)($8f889889666a75e0$var$styles.navigationContainer, t12);
        $[33] = t12;
        $[34] = t13;
    } else t13 = $[34];
    let t14;
    if ($[35] !== handlePreviousClick || $[36] !== intl || $[37] !== isAutoPlaying || $[38] !== isAutoplayEnabled) {
        t14 = isAutoplayEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.iconBackgroundColor),
            space: "space.050",
            alignInline: "start",
            testId: "carousel-navigation-autoplay"
        }, isAutoPlaying ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($k5vii))),
            label: intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).pauseAutoRotation),
            onClick: handlePausePlayClick
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZ6J4))),
            label: intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).playAutoRotation),
            onClick: handlePausePlayClick
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.iconBackgroundColor)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
            label: intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).previousSlide),
            onClick: handlePreviousClick
        }));
        $[35] = handlePreviousClick;
        $[36] = intl;
        $[37] = isAutoPlaying;
        $[38] = isAutoplayEnabled;
        $[39] = t14;
    } else t14 = $[39];
    let t15;
    if ($[40] !== cardWidthOnFullRow || $[41] !== extensionLocalId || $[42] !== frameIds || $[43] !== frames || $[44] !== handleSelect || $[45] !== intl || $[46] !== isAutoplayEnabled || $[47] !== isFirstRowFull || $[48] !== isFirstRowOverflown || $[49] !== isThumbnailNavigation || $[50] !== renderFrame || $[51] !== requestScrollIndex || $[52] !== resetScrollIndex || $[53] !== scrollToIndex || $[54] !== selectedHeroFrameIndex || $[55] !== setCurrentCardWidth || $[56] !== spaceBetweenFrames || $[57] !== throttledSetWidth) {
        t15 = isThumbnailNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.thumbnailNavigationContainer, isFirstRowOverflown ? $8f889889666a75e0$var$styles.left : $8f889889666a75e0$var$styles.center),
            style: {
                gap: `${spaceBetweenFrames}px`
            }
        }, frames.map((frame, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5D0gt.CardOrientationWrapper), {
                cardId: frameIds[index],
                key: index,
                isFirstRowFull: isFirstRowFull,
                cardWidthOnFullRow: cardWidthOnFullRow,
                setWidth: index === 0 ? setCurrentCardWidth : undefined,
                scrollToCard: index === scrollToIndex,
                clearScrollToCard: resetScrollIndex,
                testId: `carousel-navigation-content-frames-row-frame-${index}`,
                index: index,
                requestScrollIndex: requestScrollIndex,
                extensionLocalId: extensionLocalId,
                hasInlinePadding: true,
                itemDimensions: frameSize
            }, renderFrame(frame, index))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
            setWidth: throttledSetWidth,
            offscreen: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignInline: "center",
            xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.progressContainer, isAutoplayEnabled && $8f889889666a75e0$var$styles.progressPadding)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lb2UL.default), {
            values: frameIds,
            selectedIndex: selectedHeroFrameIndex,
            onSelect: handleSelect,
            ariaControls: `${(0, $gXR7h.ARIA_CONTROLS_PREFIX)}${extensionLocalId}`,
            getAriaLabel: (index_0)=>intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).slide, {
                    positionInSet: index_0 + 1,
                    setSize: frameIds.length
                })
        }));
        $[40] = cardWidthOnFullRow;
        $[41] = extensionLocalId;
        $[42] = frameIds;
        $[43] = frames;
        $[44] = handleSelect;
        $[45] = intl;
        $[46] = isAutoplayEnabled;
        $[47] = isFirstRowFull;
        $[48] = isFirstRowOverflown;
        $[49] = isThumbnailNavigation;
        $[50] = renderFrame;
        $[51] = requestScrollIndex;
        $[52] = resetScrollIndex;
        $[53] = scrollToIndex;
        $[54] = selectedHeroFrameIndex;
        $[55] = setCurrentCardWidth;
        $[56] = spaceBetweenFrames;
        $[57] = throttledSetWidth;
        $[58] = t15;
    } else t15 = $[58];
    let t16;
    if ($[59] !== handlePreviousClick || $[60] !== intl || $[61] !== isAutoplayEnabled) {
        t16 = isAutoplayEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.iconBackgroundColor)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
            label: intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).previousSlide),
            onClick: handlePreviousClick
        }));
        $[59] = handlePreviousClick;
        $[60] = intl;
        $[61] = isAutoplayEnabled;
        $[62] = t16;
    } else t16 = $[62];
    let t17;
    if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = (0, $w6R6I.cx)($8f889889666a75e0$var$styles.iconBackgroundColor);
        $[63] = t17;
    } else t17 = $[63];
    let t18;
    if ($[64] !== intl) {
        t18 = intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).nextSlide);
        $[64] = intl;
        $[65] = t18;
    } else t18 = $[65];
    let t19;
    if ($[66] !== handleNextClick || $[67] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: t17
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
            label: t18,
            onClick: handleNextClick
        }));
        $[66] = handleNextClick;
        $[67] = t18;
        $[68] = t19;
    } else t19 = $[68];
    let t20;
    if ($[69] !== t16 || $[70] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignInline: "end",
            testId: "carousel-navigation-content-cards-row-navigation"
        }, t16, t19);
        $[69] = t16;
        $[70] = t19;
        $[71] = t20;
    } else t20 = $[71];
    let t21;
    if ($[72] !== t13 || $[73] !== t14 || $[74] !== t15 || $[75] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: t13,
            space: "space.100",
            alignBlock: "center",
            testId: "carousel-navigation"
        }, t14, t15, t20);
        $[72] = t13;
        $[73] = t14;
        $[74] = t15;
        $[75] = t20;
        $[76] = t21;
    } else t21 = $[76];
    return t21;
} : ({ extensionLocalId: extensionLocalId, frames: frames, frameIds: frameIds, selectedHeroFrameIndex: selectedHeroFrameIndex, isHovered: isHovered, isCarouselVisible: isCarouselVisible, isAutoplayEnabled: isAutoplayEnabled, navigationStyle: navigationStyle, renderFrame: renderFrame, handleNavigationFrameUpdate: handleNavigationFrameUpdate, width: width = 0 })=>{
    const intl = (0, $kSwu1.useIntl)();
    const isThumbnailNavigation = navigationStyle === (0, $4MaGu.NavigationStyle).THUMBNAILS;
    const [isAutoPlaying, setIsAutoPlaying] = (0, $cozmU.useState)(isAutoplayEnabled);
    const intervalRef = (0, $cozmU.useRef)(null);
    const frameSize = (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL_V2];
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth, setCurrentCardWidth: setCurrentCardWidth } = (0, $gMXXV.useWidthAndSpacingCalculations)({
        numberOfCards: frames.length,
        cardDimensions: (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL_V2]
    });
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowFull: isFirstRowFull, gaps: gaps, maxNumberOfCardsPerRow: maxNumberOfCardsPerRow, isFirstRowOverflown: isFirstRowOverflown } = calculations;
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(setCurrentCardsGridWidth, 200);
    const spaceBetweenFrames = gaps.spaceBetweenCards;
    const { scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext, scrollToIndex: scrollToIndex, requestScrollIndex: requestScrollIndex, resetScrollIndex: resetScrollIndex } = (0, $531JC.useOrientationScrolling)({
        maxNumberOfItemsPerRow: maxNumberOfCardsPerRow,
        numberOfItems: frames?.length,
        isRow: true
    });
    const handleNextClick = (0, $cozmU.useCallback)(()=>{
        if (selectedHeroFrameIndex < frames.length - 1) {
            handleNavigationFrameUpdate(selectedHeroFrameIndex + 1);
            scrollToNext();
        } else {
            requestScrollIndex(0);
            handleNavigationFrameUpdate(0);
        }
    }, [
        selectedHeroFrameIndex,
        frames.length,
        handleNavigationFrameUpdate,
        scrollToNext,
        requestScrollIndex
    ]);
    const handlePreviousClick = (0, $cozmU.useCallback)(()=>{
        if (selectedHeroFrameIndex > 0) {
            scrollToPrevious();
            handleNavigationFrameUpdate(selectedHeroFrameIndex - 1);
        } else {
            const lastFrameIndex = frames.length - 1;
            requestScrollIndex(lastFrameIndex);
            handleNavigationFrameUpdate(lastFrameIndex);
        }
    }, [
        selectedHeroFrameIndex,
        frames.length,
        handleNavigationFrameUpdate,
        scrollToPrevious,
        requestScrollIndex
    ]);
    const handlePausePlayClick = ()=>{
        setIsAutoPlaying((prev)=>!prev);
    };
    const handleSelect = ({ index: selectedIndex })=>{
        handleNavigationFrameUpdate(selectedIndex);
    }; // This useEffect is used to Auto-scroll every X seconds
    (0, $cozmU.useEffect)(()=>{
        if (isAutoPlaying && !isHovered) intervalRef.current = setInterval(()=>{
            if (isCarouselVisible()) handleNextClick();
        }, (0, $gXR7h.AUTOPLAY_SECONDS) * 1000);
        return ()=>{
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [
        isAutoPlaying,
        isCarouselVisible,
        isHovered,
        selectedHeroFrameIndex,
        handleNextClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.navigationContainer, width > $8f889889666a75e0$var$NAVIGATION_PADDING_BREAKPOINT_WIDTH && $8f889889666a75e0$var$styles.navigationContainerWithPadding),
        space: "space.100",
        alignBlock: "center",
        testId: "carousel-navigation"
    }, isAutoplayEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.iconBackgroundColor),
        space: "space.050",
        alignInline: "start",
        testId: "carousel-navigation-autoplay"
    }, isAutoPlaying ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($k5vii))),
        label: intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).pauseAutoRotation),
        onClick: handlePausePlayClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZ6J4))),
        label: intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).playAutoRotation),
        onClick: handlePausePlayClick
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.iconBackgroundColor)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).previousSlide),
        onClick: handlePreviousClick
    })), isThumbnailNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.thumbnailNavigationContainer, isFirstRowOverflown ? $8f889889666a75e0$var$styles.left : $8f889889666a75e0$var$styles.center),
        style: {
            gap: `${spaceBetweenFrames}px`
        }
    }, frames.map((frame, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5D0gt.CardOrientationWrapper), {
            cardId: frameIds[index],
            key: index,
            isFirstRowFull: isFirstRowFull,
            cardWidthOnFullRow: cardWidthOnFullRow,
            setWidth: index === 0 ? setCurrentCardWidth : undefined,
            scrollToCard: index === scrollToIndex,
            clearScrollToCard: resetScrollIndex,
            testId: `carousel-navigation-content-frames-row-frame-${index}`,
            index: index,
            requestScrollIndex: requestScrollIndex,
            extensionLocalId: extensionLocalId,
            hasInlinePadding: true,
            itemDimensions: frameSize
        }, renderFrame(frame, index))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
        setWidth: throttledSetWidth,
        offscreen: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignInline: "center",
        xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.progressContainer, isAutoplayEnabled && $8f889889666a75e0$var$styles.progressPadding)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lb2UL.default), {
        values: frameIds,
        selectedIndex: selectedHeroFrameIndex,
        onSelect: handleSelect,
        ariaControls: `${(0, $gXR7h.ARIA_CONTROLS_PREFIX)}${extensionLocalId}`,
        getAriaLabel: (index_0)=>intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).slide, {
                positionInSet: index_0 + 1,
                setSize: frameIds.length
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignInline: "end",
        testId: "carousel-navigation-content-cards-row-navigation"
    }, isAutoplayEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.iconBackgroundColor)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).previousSlide),
        onClick: handlePreviousClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: (0, $w6R6I.cx)($8f889889666a75e0$var$styles.iconBackgroundColor)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        label: intl.formatMessage((0, $b5e25217b125fc4a$export$defe85febe8b728c).nextSlide),
        onClick: handleNextClick
    }))));
};
function $8f889889666a75e0$var$_temp(prev) {
    return !prev;
}





const $32250fb74b6e09f1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    frameLabel: {
        id: "company-hub.carousel-extension.card-strip.card.label",
        defaultMessage: "slide {positionInSet} of {setSize}"
    }
});


const $58e21593b205ee37$var$Frame = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLastFrame: isLastFrame, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1VN2R3XzJH _0sd2lMXzJH _1ubuxo98eZ _1NDpvbYbGa _2wtOC9T6kp",
            __cmplp.isLastFrame ? "_0adFHsPgdg" : "_0adFHs8HPE",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastFrame: isLastFrame, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1VN2R3XzJH _0sd2lMXzJH _1ubuxo98eZ _1NDpvbYbGa _2wtOC9T6kp",
            __cmplp.isLastFrame ? "_0adFHsPgdg" : "_0adFHs8HPE",
            __cmplp.className
        ])
    });
});
const $58e21593b205ee37$var$FrameNew = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLastFrame: isLastFrame, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV023w0h",
            __cmplp.isLastFrame ? "_0adFHsPgdg" : "_0adFHs8HPE",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastFrame: isLastFrame, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV023w0h",
            __cmplp.isLastFrame ? "_0adFHsPgdg" : "_0adFHs8HPE",
            __cmplp.className
        ])
    });
});
const $58e21593b205ee37$export$dfca4ddd2f0987f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { isInViewMode: isInViewMode, frames: frames, frameIds: frameIds, selectedHeroFrameIndex: selectedHeroFrameIndex, isHovered: t1, extensionLocalId: t2, isAutoplayEnabled: t3, isCarouselVisible: isCarouselVisible, navigationStyle: t4, setSelectedHeroFrameIndex: setSelectedHeroFrameIndex, width: width } = t0;
    const isHovered = t1 === undefined ? false : t1;
    const extensionLocalId = t2 === undefined ? "default-extension-local-id" : t2;
    const isAutoplayEnabled = t3 === undefined ? false : t3;
    const navigationStyle = t4 === undefined ? (0, $4MaGu.NavigationStyle).THUMBNAILS : t4;
    const intl = (0, $kSwu1.useIntl)();
    const [, t5] = (0, $bIp5p.useExtensionsState)();
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = t5;
    let t6;
    if ($[0] !== frameIds || $[1] !== isInViewMode || $[2] !== setIsInAutoFocusMode || $[3] !== setSelectedHeroFrameIndex || $[4] !== setSelectedToEditCardId) {
        t6 = (index)=>{
            setSelectedHeroFrameIndex(index);
            if (!isInViewMode) {
                setIsInAutoFocusMode(true);
                setSelectedToEditCardId(frameIds[index]);
            }
        };
        $[0] = frameIds;
        $[1] = isInViewMode;
        $[2] = setIsInAutoFocusMode;
        $[3] = setSelectedHeroFrameIndex;
        $[4] = setSelectedToEditCardId;
        $[5] = t6;
    } else t6 = $[5];
    const handleUpdateCardOnNavigation = t6;
    let t7;
    if ($[6] !== handleUpdateCardOnNavigation) {
        t7 = (event, index_0)=>{
            event?.stopPropagation();
            handleUpdateCardOnNavigation(index_0);
        };
        $[6] = handleUpdateCardOnNavigation;
        $[7] = t7;
    } else t7 = $[7];
    const handleSelectFrame = t7;
    let t8;
    if ($[8] !== handleSelectFrame) {
        t8 = (event_0, index_1)=>{
            event_0.stopPropagation();
            const ACTIVATE_BUTTON_KEYS = [
                "Enter",
                "Spacebar",
                " "
            ];
            if (ACTIVATE_BUTTON_KEYS.includes(event_0.key)) {
                event_0.preventDefault();
                handleSelectFrame(undefined, index_1);
            }
        };
        $[8] = handleSelectFrame;
        $[9] = t8;
    } else t8 = $[9];
    const handleKeyDownAsButtonClick = t8;
    let t9;
    if ($[10] !== frameIds || $[11] !== frames.length || $[12] !== handleKeyDownAsButtonClick || $[13] !== handleSelectFrame || $[14] !== intl || $[15] !== selectedHeroFrameIndex) {
        t9 = (card, index_2)=>(0, $ieeJu.expValEquals)("company_hub_carousel_thumbnails-refactor", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58e21593b205ee37$var$FrameNew, {
                key: frameIds[index_2],
                "data-testid": "frame-strip-frame",
                tabIndex: 0,
                isLastFrame: index_2 === frames.length - 1
            }, card) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58e21593b205ee37$var$Frame, {
                key: frameIds[index_2],
                "data-testid": "frame-strip-frame",
                role: "button",
                tabIndex: 0,
                "aria-current": selectedHeroFrameIndex === index_2,
                "aria-label": intl.formatMessage((0, $32250fb74b6e09f1$export$defe85febe8b728c).frameLabel, {
                    positionInSet: index_2 + 1,
                    setSize: frames.length
                }),
                onClick: (event_1)=>handleSelectFrame(event_1, index_2),
                onKeyDown: (event_2)=>handleKeyDownAsButtonClick(event_2, index_2),
                isLastFrame: index_2 === frames.length - 1
            }, card);
        $[10] = frameIds;
        $[11] = frames.length;
        $[12] = handleKeyDownAsButtonClick;
        $[13] = handleSelectFrame;
        $[14] = intl;
        $[15] = selectedHeroFrameIndex;
        $[16] = t9;
    } else t9 = $[16];
    const renderFrame = t9;
    let t10;
    if ($[17] !== extensionLocalId || $[18] !== frameIds || $[19] !== frames || $[20] !== handleUpdateCardOnNavigation || $[21] !== isAutoplayEnabled || $[22] !== isCarouselVisible || $[23] !== isHovered || $[24] !== navigationStyle || $[25] !== renderFrame || $[26] !== selectedHeroFrameIndex || $[27] !== width) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8f889889666a75e0$export$bb2ef5dc2942d541), {
            width: width,
            frames: frames,
            frameIds: frameIds,
            extensionLocalId: extensionLocalId,
            renderFrame: renderFrame,
            handleNavigationFrameUpdate: handleUpdateCardOnNavigation,
            selectedHeroFrameIndex: selectedHeroFrameIndex,
            isHovered: isHovered,
            isCarouselVisible: isCarouselVisible,
            isAutoplayEnabled: isAutoplayEnabled,
            navigationStyle: navigationStyle
        });
        $[17] = extensionLocalId;
        $[18] = frameIds;
        $[19] = frames;
        $[20] = handleUpdateCardOnNavigation;
        $[21] = isAutoplayEnabled;
        $[22] = isCarouselVisible;
        $[23] = isHovered;
        $[24] = navigationStyle;
        $[25] = renderFrame;
        $[26] = selectedHeroFrameIndex;
        $[27] = width;
        $[28] = t10;
    } else t10 = $[28];
    return t10;
} : ({ isInViewMode: isInViewMode, frames: frames, frameIds: frameIds, selectedHeroFrameIndex: selectedHeroFrameIndex, isHovered: isHovered = false, extensionLocalId: extensionLocalId = 'default-extension-local-id', isAutoplayEnabled: isAutoplayEnabled = false, isCarouselVisible: isCarouselVisible, navigationStyle: navigationStyle = (0, $4MaGu.NavigationStyle).THUMBNAILS, setSelectedHeroFrameIndex: setSelectedHeroFrameIndex, width: width })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [_state, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $bIp5p.useExtensionsState)();
    const handleUpdateCardOnNavigation = (0, $cozmU.useCallback)((index)=>{
        setSelectedHeroFrameIndex(index);
        if (!isInViewMode) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(frameIds[index]);
        }
    }, [
        setSelectedHeroFrameIndex,
        isInViewMode,
        setSelectedToEditCardId,
        setIsInAutoFocusMode,
        frameIds
    ]);
    const handleSelectFrame = (0, $cozmU.useCallback)((event, index_0)=>{
        event?.stopPropagation();
        handleUpdateCardOnNavigation(index_0);
    }, [
        handleUpdateCardOnNavigation
    ]);
    const handleKeyDownAsButtonClick = (0, $cozmU.useCallback)((event_0, index_1)=>{
        event_0.stopPropagation(); // Keyboard support for button: https://www.w3.org/TR/wai-aria-practices/examples/button/button.html
        // event.key spec: https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
        const ACTIVATE_BUTTON_KEYS = [
            'Enter',
            'Spacebar',
            ' '
        ];
        if (ACTIVATE_BUTTON_KEYS.includes(event_0.key)) {
            event_0.preventDefault();
            handleSelectFrame(undefined, index_1);
        }
    }, [
        handleSelectFrame
    ]);
    const renderFrame = (0, $cozmU.useCallback)((card, index_2)=>{
        return (0, $ieeJu.expValEquals)('company_hub_carousel_thumbnails-refactor', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58e21593b205ee37$var$FrameNew, {
            key: frameIds[index_2],
            "data-testid": "frame-strip-frame",
            tabIndex: 0,
            isLastFrame: index_2 === frames.length - 1
        }, card) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58e21593b205ee37$var$Frame, {
            key: frameIds[index_2],
            "data-testid": "frame-strip-frame",
            role: "button",
            tabIndex: 0,
            "aria-current": selectedHeroFrameIndex === index_2,
            "aria-label": intl.formatMessage((0, $32250fb74b6e09f1$export$defe85febe8b728c).frameLabel, {
                positionInSet: index_2 + 1,
                setSize: frames.length
            }),
            onClick: (event_1)=>handleSelectFrame(event_1, index_2),
            onKeyDown: (event_2)=>handleKeyDownAsButtonClick(event_2, index_2),
            isLastFrame: index_2 === frames.length - 1
        }, card);
    }, [
        intl,
        frames,
        frameIds,
        selectedHeroFrameIndex,
        handleSelectFrame,
        handleKeyDownAsButtonClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8f889889666a75e0$export$bb2ef5dc2942d541), {
        width: width,
        frames: frames,
        frameIds: frameIds,
        extensionLocalId: extensionLocalId,
        renderFrame: renderFrame,
        handleNavigationFrameUpdate: handleUpdateCardOnNavigation,
        selectedHeroFrameIndex: selectedHeroFrameIndex,
        isHovered: isHovered,
        isCarouselVisible: isCarouselVisible,
        isAutoplayEnabled: isAutoplayEnabled,
        navigationStyle: navigationStyle
    });
};
const $58e21593b205ee37$export$6239edc19b7276da = (0, $9ECRl.default)($58e21593b205ee37$export$dfca4ddd2f0987f2, {
    overflowSelector: '.frame-strip-overflow',
    useShadowObserver: true
});



var $5Sbqg = parcelRequire("5Sbqg");













var $9aYkv = parcelRequire("9aYkv");








var $cJ0FD = parcelRequire("cJ0FD");





var $kh0hi = parcelRequire("kh0hi");


var $3qg1D = parcelRequire("3qg1D");

var $4yYAm = parcelRequire("4yYAm");

var $voDgt = parcelRequire("voDgt");

var $jdA6O = parcelRequire("jdA6O");


var $QXwxo = parcelRequire("QXwxo");





var $jIDse = parcelRequire("jIDse");



const $2838595878231140$export$1861ee29fc9bca35 = 'https://www.atlassian.com/';
const $2838595878231140$export$ea1683885a045a91 = ()=>{
    if (typeof window === 'undefined' || !window.location?.href) return $2838595878231140$export$1861ee29fc9bca35;
    return window.location.href;
};




var $9QaSD = parcelRequire("9QaSD");


var $4ZwXK = parcelRequire("4ZwXK");

var $iMYjN = parcelRequire("iMYjN");


var $je216 = parcelRequire("je216");


















const $9cfdd7a6556c2c02$var$commonSmartlinkOverrideStyles = null;
const $9cfdd7a6556c2c02$export$1380ef7d0b342537 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isSelected: isSelected, isHero: isHero, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_14c24o2Njc _178ZPhdnbC _063gzlN91d _3tIHT67dHp _0EfHOHN91d",
            __cmplp.isSelected ? "_1USPvduieU" : "_1USPvdYnmg",
            __cmplp.isHero ? "_3fHFFbICEG" : "_3fHFFb7zJH",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, isHero: isHero, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_14c24o2Njc _178ZPhdnbC _063gzlN91d _3tIHT67dHp _0EfHOHN91d",
            __cmplp.isSelected ? "_1USPvduieU" : "_1USPvdYnmg",
            __cmplp.isHero ? "_3fHFFbICEG" : "_3fHFFb7zJH",
            __cmplp.className
        ])
    });
});
const $9cfdd7a6556c2c02$export$eb2540e3027f8342 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(14);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { minWidth: minWidth, maxWidth: maxWidth, hasRoundedCorners: hasRoundedCorners, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.height}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        const t5 = `${__cmplp.minWidth}px`;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $9aYkv.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        const t7 = `${__cmplp.maxWidth}px`;
        let t8;
        if ($[7] !== t7) {
            t8 = (0, $9aYkv.default)(t7);
            $[7] = t7;
            $[8] = t8;
        } else t8 = $[8];
        let t9;
        if ($[9] !== __cmpls || $[10] !== t4 || $[11] !== t6 || $[12] !== t8) {
            t9 = {
                ...__cmpls,
                "--_1neqek2": t4,
                "--_zam2fy": t6,
                "--_zncvnb": t8
            };
            $[9] = __cmpls;
            $[10] = t4;
            $[11] = t6;
            $[12] = t8;
            $[13] = t9;
        } else t9 = $[13];
        t1 = /*#__PURE__*/ $cozmU.createElement(C, {
            ...__cmpldp,
            style: t9,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1deZihnQyn _4xmOrXnQyn _2HOV1d7dHp _2m1GHN1qpb _2GgwmdiKjo _2pIp5KfOPC _4w7rC7tvcA _3QsqkudnbC _2uFry7dnbC _1vQlygchRC _3RYleMDIqT _2SUnVV7zJH _3yDo7ubvKs _2ktaTxVSkq",
                __cmplp.hasRoundedCorners ? "_0jMlVyUNDJ" : "_0jMlVydnbC",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, maxWidth: maxWidth, hasRoundedCorners: hasRoundedCorners, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9aYkv.default)(`${__cmplp.height}px`),
            "--_zam2fy": (0, $9aYkv.default)(`${__cmplp.minWidth}px`),
            "--_zncvnb": (0, $9aYkv.default)(`${__cmplp.maxWidth}px`)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1deZihnQyn _4xmOrXnQyn _2HOV1d7dHp _2m1GHN1qpb _2GgwmdiKjo _2pIp5KfOPC _4w7rC7tvcA _3QsqkudnbC _2uFry7dnbC _1vQlygchRC _3RYleMDIqT _2SUnVV7zJH _3yDo7ubvKs _2ktaTxVSkq",
            __cmplp.hasRoundedCorners ? "_0jMlVyUNDJ" : "_0jMlVydnbC",
            __cmplp.className
        ])
    });
});





const $cb2865cafee6fe8a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title",
        defaultMessage: "Add a title"
    }
});


const $6c060bae43cf38d9$var$NavigationThumbnailWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(14);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { minWidth: minWidth, maxWidth: maxWidth, hasRoundedCorners: hasRoundedCorners, isSelected: isSelected, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.height}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        const t5 = `${__cmplp.minWidth}px`;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $9aYkv.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        const t7 = `${__cmplp.maxWidth}px`;
        let t8;
        if ($[7] !== t7) {
            t8 = (0, $9aYkv.default)(t7);
            $[7] = t7;
            $[8] = t8;
        } else t8 = $[8];
        let t9;
        if ($[9] !== __cmpls || $[10] !== t4 || $[11] !== t6 || $[12] !== t8) {
            t9 = {
                ...__cmpls,
                "--_1neqek2": t4,
                "--_zam2fy": t6,
                "--_zncvnb": t8
            };
            $[9] = __cmpls;
            $[10] = t4;
            $[11] = t6;
            $[12] = t8;
            $[13] = t9;
        } else t9 = $[13];
        t1 = /*#__PURE__*/ $cozmU.createElement(C, {
            ...__cmpldp,
            style: t9,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _3YEZNO7dHp _0aFT5v1qpb _0jFU0ViKjo _4ouGXIfOPC _1EqgXltvcA",
                __cmplp.hasRoundedCorners ? "_0bjKvDUNDJ" : "_0bjKvDdnbC",
                __cmplp.isSelected ? "_3vBAKHrzt2" : "_3vBAKHDMqu",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, maxWidth: maxWidth, hasRoundedCorners: hasRoundedCorners, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9aYkv.default)(`${__cmplp.height}px`),
            "--_zam2fy": (0, $9aYkv.default)(`${__cmplp.minWidth}px`),
            "--_zncvnb": (0, $9aYkv.default)(`${__cmplp.maxWidth}px`)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _3YEZNO7dHp _0aFT5v1qpb _0jFU0ViKjo _4ouGXIfOPC _1EqgXltvcA",
            __cmplp.hasRoundedCorners ? "_0bjKvDUNDJ" : "_0bjKvDdnbC",
            __cmplp.isSelected ? "_3vBAKHrzt2" : "_3vBAKHDMqu",
            __cmplp.className
        ])
    });
});
const $6c060bae43cf38d9$var$styles = {
    pressable: "_0Of8r2Ll21 _1wydGWLl21 _2Zuz6QB0rP _39xV02N91d _0KLXruutHW",
    container: "_0jFU0VUF4f",
    selectedToEdit: "_32BiAhXzJH",
    selectedToRemove: "_32BiAhOvEe",
    image: "_39xV02pJKa _0jFU0VUF4f",
    textWrapper: "_2Zuz6Q2ADO _0Of8r21Y8M _1wydGW1Y8M"
};
const $6c060bae43cf38d9$var$textStyles = null;
const $6c060bae43cf38d9$export$3c072ff478476aa0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { cardId: cardId, link: link, title: title, imageSrc: imageSrc, isSelected: isSelected, contentId: contentId, isEmpty: isEmpty, minWidth: minWidth, maxWidth: maxWidth, wrapperHeight: wrapperHeight, hasRoundedCorners: hasRoundedCorners, layout: layout, backgroundColor: savedBackgroundColor, onFailed: onFailed, onSucceeded: onSucceeded, setSelectedHeroFrameIndex: setSelectedHeroFrameIndex, index: index, isSelectedToEdit: isSelectedToEdit, isSelectedToRemove: isSelectedToRemove } = t0;
    const { isRestricted: isRestricted, isUnauthorized: isUnauthorized, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onSucceeded, onFailed);
    const intl = (0, $kSwu1.useIntl)();
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const displayImageSrc = (0, $je216.useResolveImage)(link, imageSrc);
    let t1;
    if ($[0] !== displayImageSrc) {
        t1 = (0, $iMYjN.getImageTypeToShow)({
            imageSrc: displayImageSrc
        });
        $[0] = displayImageSrc;
        $[1] = t1;
    } else t1 = $[1];
    const { showUnsplashImage: showUnsplashImage, showExternalSiteImage: showExternalSiteImage, showCustomUploadedImage: showCustomUploadedImage } = t1;
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    const t2 = savedBackgroundColor ?? "#FFFFFF";
    let t3;
    if ($[2] !== getDarkModeCompatibleBackgroundColor || $[3] !== t2) {
        t3 = getDarkModeCompatibleBackgroundColor(t2);
        $[2] = getDarkModeCompatibleBackgroundColor;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const backgroundColor = t3;
    const substituteBackgroundColorForImage = layout === (0, $hjUDQ.CommonLayout).NO_IMAGE_BACKGROUND && backgroundColor;
    const showCustomTitleUnauthed = isUnauthorized && !!title;
    const showCustomTitleRestricted = isRestricted && !!title;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $2838595878231140$export$ea1683885a045a91)();
        $[5] = t4;
    } else t4 = $[5];
    const fallbackUrl = t4;
    let t5;
    if ($[6] !== backgroundColor || $[7] !== cardId || $[8] !== contentId || $[9] !== displayImageSrc || $[10] !== hasRoundedCorners || $[11] !== intl || $[12] !== isEmpty || $[13] !== isSelected || $[14] !== link || $[15] !== maxWidth || $[16] !== minWidth || $[17] !== showCustomTitleRestricted || $[18] !== showCustomTitleUnauthed || $[19] !== showCustomUploadedImage || $[20] !== showExternalSiteImage || $[21] !== showUnsplashImage || $[22] !== substituteBackgroundColorForImage || $[23] !== title || $[24] !== trackAndCategorizeError || $[25] !== trackSuccess || $[26] !== wrapperHeight) {
        t5 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $9cfdd7a6556c2c02$export$1380ef7d0b342537), {
                isSelected: isSelected
            }, /*#__PURE__*/ $cozmU.createElement((0, $9cfdd7a6556c2c02$export$eb2540e3027f8342), {
                minWidth: minWidth ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].minWidth,
                maxWidth: maxWidth ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].maxWidth,
                height: wrapperHeight ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].height,
                hasRoundedCorners: hasRoundedCorners
            }, /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
                id: cardId,
                appearance: "inline",
                frameStyle: "show",
                platform: "web",
                ui: {
                    theme: (0, $4yYAm.SmartLinkTheme).Black,
                    clickableContainer: false,
                    size: (0, $4yYAm.SmartLinkSize).Large
                },
                url: link || fallbackUrl,
                onResolve: trackSuccess,
                onError: trackAndCategorizeError
            }, substituteBackgroundColorForImage && /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), null, /*#__PURE__*/ $cozmU.createElement("div", {
                style: {
                    backgroundColor: backgroundColor
                },
                "data-testid": "backgroundColorBlock",
                className: (0, $hekY6.default)([
                    $6c060bae43cf38d9$var$customBackgroundStyles.backgroundColorOnly
                ])
            })), !substituteBackgroundColorForImage && (showUnsplashImage || showExternalSiteImage) && /*#__PURE__*/ $cozmU.createElement((0, $voDgt.default), {
                ignoreContainerPadding: true,
                placement: (0, $4yYAm.MediaPlacement).Left,
                overrideUrl: displayImageSrc
            }), !substituteBackgroundColorForImage && showCustomUploadedImage ? /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
                className: (0, $hekY6.default)([
                    "_1mT5xdWVPG _39xV02L04q _2IhTonPgdg _0Bm75GPgdg _3OE6xYPgdg",
                    "_39xV02p0Oa"
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $4ZwXK.CustomImageUploadRenderer), {
                contentId: contentId,
                imageSrc: displayImageSrc
            })) : null, /*#__PURE__*/ $cozmU.createElement((0, $jdA6O.default), {
                hideIcon: true,
                text: isEmpty ? title || intl.formatMessage((0, $cb2865cafee6fe8a$export$defe85febe8b728c).emptyStatePlaceholderTitle) : title,
                maxLines: 2,
                anchorTarget: "_self",
                className: (0, $hekY6.default)([
                    "_313842Pgdg _2XsHFM1Y8M _39xV02N91d _0luBOg98eZ _0uGipI98eZ _0DlTgX98eZ _1Oh6lc98eZ _1KbF3r98eZ _2h5UOzYbGa _2LQVB4YbGa _27PHXJYbGa _38ddKyYbGa _1R2oCZYbGa _3W2WEt6wH8 _4BW6TR6wH8 _2IWu1s6wH8 _4i4dA66wH8 _06nYrP6wH8 _1PV8ifYbGa _37c0tEYbGa _0pmIhFYbGa _1205DiYbGa _0RVZIUYbGa _2laob1u7m9 _09qmHg7dHp",
                    (showCustomTitleUnauthed || showCustomTitleRestricted) && "_26XUdrYbGa",
                    isEmpty && !title ? "_2WYQpZKGUX" : "_2WYQpZy7kJ"
                ])
            }))));
        $[6] = backgroundColor;
        $[7] = cardId;
        $[8] = contentId;
        $[9] = displayImageSrc;
        $[10] = hasRoundedCorners;
        $[11] = intl;
        $[12] = isEmpty;
        $[13] = isSelected;
        $[14] = link;
        $[15] = maxWidth;
        $[16] = minWidth;
        $[17] = showCustomTitleRestricted;
        $[18] = showCustomTitleUnauthed;
        $[19] = showCustomUploadedImage;
        $[20] = showExternalSiteImage;
        $[21] = showUnsplashImage;
        $[22] = substituteBackgroundColorForImage;
        $[23] = title;
        $[24] = trackAndCategorizeError;
        $[25] = trackSuccess;
        $[26] = wrapperHeight;
        $[27] = t5;
    } else t5 = $[27];
    const oldThumbnail = t5;
    let t6;
    if ($[28] !== contentId || $[29] !== displayImageSrc || $[30] !== hasRoundedCorners || $[31] !== index || $[32] !== intl || $[33] !== isSelected || $[34] !== isSelectedToEdit || $[35] !== isSelectedToRemove || $[36] !== maxWidth || $[37] !== minWidth || $[38] !== oldThumbnail || $[39] !== setSelectedHeroFrameIndex || $[40] !== showCustomUploadedImage || $[41] !== title || $[42] !== wrapperHeight) {
        t6 = (0, $ieeJu.expValEquals)("company_hub_carousel_thumbnails-refactor", "isEnabled", true) ? /*#__PURE__*/ $cozmU.createElement($6c060bae43cf38d9$var$NavigationThumbnailWrapper, {
            minWidth: minWidth ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].minWidth,
            maxWidth: maxWidth ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].maxWidth,
            height: wrapperHeight ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].height,
            hasRoundedCorners: hasRoundedCorners,
            isSelected: isSelected
        }, /*#__PURE__*/ $cozmU.createElement((0, $kh0hi.default), {
            testId: "thumbnail",
            xcss: (0, $w6R6I.cx)($6c060bae43cf38d9$var$styles.pressable, isSelectedToEdit && $6c060bae43cf38d9$var$styles.selectedToEdit, isSelectedToRemove && $6c060bae43cf38d9$var$styles.selectedToRemove),
            onClick: ()=>setSelectedHeroFrameIndex(index)
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "start",
            xcss: $6c060bae43cf38d9$var$styles.container
        }, showCustomUploadedImage ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6c060bae43cf38d9$var$styles.image
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ZwXK.CustomImageUploadRenderer), {
            contentId: contentId,
            imageSrc: displayImageSrc
        })) : displayImageSrc ? /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: displayImageSrc,
            alt: "",
            className: (0, $hekY6.default)([
                $6c060bae43cf38d9$var$styles.image
            ])
        }) : /*#__PURE__*/ $cozmU.createElement("div", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                $6c060bae43cf38d9$var$styles.image
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6c060bae43cf38d9$var$styles.textWrapper
            ])
        }, /*#__PURE__*/ $cozmU.createElement("p", {
            className: (0, $hekY6.default)([
                "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0e1mPoHnLE _2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _2fwxA57p2s _3iDTPbgJ9S _4Gn54RiZR3 _1U1ZhbbI28 _118UhSYKtr"
            ])
        }, title || intl.formatMessage((0, $cb2865cafee6fe8a$export$defe85febe8b728c).emptyStatePlaceholderTitle)))))) : oldThumbnail();
        $[28] = contentId;
        $[29] = displayImageSrc;
        $[30] = hasRoundedCorners;
        $[31] = index;
        $[32] = intl;
        $[33] = isSelected;
        $[34] = isSelectedToEdit;
        $[35] = isSelectedToRemove;
        $[36] = maxWidth;
        $[37] = minWidth;
        $[38] = oldThumbnail;
        $[39] = setSelectedHeroFrameIndex;
        $[40] = showCustomUploadedImage;
        $[41] = title;
        $[42] = wrapperHeight;
        $[43] = t6;
    } else t6 = $[43];
    return t6;
} : ({ cardId: cardId, link: link, title: title, imageSrc: imageSrc, isSelected: isSelected, contentId: contentId, isEmpty: isEmpty, minWidth: minWidth, maxWidth: maxWidth, wrapperHeight: wrapperHeight, hasRoundedCorners: hasRoundedCorners, layout: layout, backgroundColor: savedBackgroundColor, onFailed: onFailed, onSucceeded: onSucceeded, setSelectedHeroFrameIndex: setSelectedHeroFrameIndex, index: index, isSelectedToEdit: isSelectedToEdit, isSelectedToRemove: isSelectedToRemove })=>{
    const { isRestricted: isRestricted, isUnauthorized: isUnauthorized, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onSucceeded, onFailed);
    const intl = (0, $kSwu1.useIntl)();
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const displayImageSrc = (0, $je216.useResolveImage)(link, imageSrc);
    const { showUnsplashImage: showUnsplashImage, showExternalSiteImage: showExternalSiteImage, showCustomUploadedImage: showCustomUploadedImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    const backgroundColor = getDarkModeCompatibleBackgroundColor(savedBackgroundColor ?? '#FFFFFF');
    const substituteBackgroundColorForImage = layout === (0, $hjUDQ.CommonLayout).NO_IMAGE_BACKGROUND && backgroundColor;
    const showCustomTitleUnauthed = isUnauthorized && !!title;
    const showCustomTitleRestricted = isRestricted && !!title;
    const fallbackUrl = (0, $2838595878231140$export$ea1683885a045a91)();
    const oldThumbnail = ()=>/*#__PURE__*/ $cozmU.createElement((0, $9cfdd7a6556c2c02$export$1380ef7d0b342537), {
            isSelected: isSelected
        }, /*#__PURE__*/ $cozmU.createElement((0, $9cfdd7a6556c2c02$export$eb2540e3027f8342), {
            minWidth: minWidth ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].minWidth,
            maxWidth: maxWidth ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].maxWidth,
            height: wrapperHeight ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].height,
            hasRoundedCorners: hasRoundedCorners
        }, /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            platform: "web",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: false,
                size: (0, $4yYAm.SmartLinkSize).Large
            },
            url: link || fallbackUrl,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError
        }, substituteBackgroundColorForImage && /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), null, /*#__PURE__*/ $cozmU.createElement("div", {
            style: {
                backgroundColor: backgroundColor
            },
            "data-testid": "backgroundColorBlock",
            className: (0, $hekY6.default)([
                $6c060bae43cf38d9$var$customBackgroundStyles.backgroundColorOnly
            ])
        })), !substituteBackgroundColorForImage && (showUnsplashImage || showExternalSiteImage) && /*#__PURE__*/ $cozmU.createElement((0, $voDgt.default), {
            ignoreContainerPadding: true,
            placement: (0, $4yYAm.MediaPlacement).Left,
            overrideUrl: displayImageSrc
        }), !substituteBackgroundColorForImage && showCustomUploadedImage ? /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _39xV02L04q _2IhTonPgdg _0Bm75GPgdg _3OE6xYPgdg",
                "_39xV02p0Oa"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ZwXK.CustomImageUploadRenderer), {
            contentId: contentId,
            imageSrc: displayImageSrc
        })) : null, /*#__PURE__*/ $cozmU.createElement((0, $jdA6O.default), {
            hideIcon: true,
            text: // a link with no title should expect undefined
            isEmpty ? title || intl.formatMessage((0, $cb2865cafee6fe8a$export$defe85febe8b728c).emptyStatePlaceholderTitle) : title,
            maxLines: 2,
            anchorTarget: "_self",
            className: (0, $hekY6.default)([
                "_313842Pgdg _2XsHFM1Y8M _39xV02N91d _0luBOg98eZ _0uGipI98eZ _0DlTgX98eZ _1Oh6lc98eZ _1KbF3r98eZ _2h5UOzYbGa _2LQVB4YbGa _27PHXJYbGa _38ddKyYbGa _1R2oCZYbGa _3W2WEt6wH8 _4BW6TR6wH8 _2IWu1s6wH8 _4i4dA66wH8 _06nYrP6wH8 _1PV8ifYbGa _37c0tEYbGa _0pmIhFYbGa _1205DiYbGa _0RVZIUYbGa _2laob1u7m9 _09qmHg7dHp",
                (showCustomTitleUnauthed || showCustomTitleRestricted) && "_26XUdrYbGa",
                isEmpty && !title ? "_2WYQpZKGUX" : "_2WYQpZy7kJ"
            ])
        }))));
    return (0, $ieeJu.expValEquals)('company_hub_carousel_thumbnails-refactor', 'isEnabled', true) ? /*#__PURE__*/ $cozmU.createElement($6c060bae43cf38d9$var$NavigationThumbnailWrapper, {
        minWidth: minWidth ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].minWidth,
        maxWidth: maxWidth ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].maxWidth,
        height: wrapperHeight ?? (0, $4MaGu.framesDimensions)[(0, $4MaGu.FrameSizes).NAVIGATION_THUMBNAIL].height,
        hasRoundedCorners: hasRoundedCorners,
        isSelected: isSelected
    }, /*#__PURE__*/ $cozmU.createElement((0, $kh0hi.default), {
        testId: "thumbnail",
        xcss: (0, $w6R6I.cx)($6c060bae43cf38d9$var$styles.pressable, isSelectedToEdit && $6c060bae43cf38d9$var$styles.selectedToEdit, isSelectedToRemove && $6c060bae43cf38d9$var$styles.selectedToRemove),
        onClick: ()=>setSelectedHeroFrameIndex(index)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "start",
        xcss: $6c060bae43cf38d9$var$styles.container
    }, showCustomUploadedImage ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $6c060bae43cf38d9$var$styles.image
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ZwXK.CustomImageUploadRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc
    })) : displayImageSrc ? /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: displayImageSrc,
        alt: "",
        className: (0, $hekY6.default)([
            $6c060bae43cf38d9$var$styles.image
        ])
    }) : /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            $6c060bae43cf38d9$var$styles.image
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $6c060bae43cf38d9$var$styles.textWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement("p", {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0e1mPoHnLE _2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _2fwxA57p2s _3iDTPbgJ9S _4Gn54RiZR3 _1U1ZhbbI28 _118UhSYKtr"
        ])
    }, title || intl.formatMessage((0, $cb2865cafee6fe8a$export$defe85febe8b728c).emptyStatePlaceholderTitle)))))) : oldThumbnail();
};
const $6c060bae43cf38d9$var$titleBlockLinkTextColorStyles = null;
const $6c060bae43cf38d9$var$titleBlockLinkTextSubtlestColorStyles = null;
const $6c060bae43cf38d9$var$titleBlockHideUnauthorizedStyles = null;
const $6c060bae43cf38d9$var$titleBlockStylesV2 = null;
const $6c060bae43cf38d9$var$customImageUploadStyles = null;
const $6c060bae43cf38d9$var$customBackgroundStyles = {
    backgroundColorOnly: "_1mT5xdWVPG _39xV02QZy0 _2IhTonPgdg _0Bm75GPgdg _3OE6xYPgdg"
};
const $6c060bae43cf38d9$var$carouselV2CustomImageWidth = null;


const $b0191e7cc5b82c5b$var$IMAGE_PERCENTAGE = 0.575;
const $b0191e7cc5b82c5b$var$styles = {
    containerStyles: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1mT5xdRAKS _0aFT5v1qpb _39xV02N91d _37wbyuchRC _1OHb6iLkD4"
};
const $b0191e7cc5b82c5b$export$daaa732503241aed = (carouselRef)=>{
    if (!carouselRef.current) return false;
    const rect = carouselRef.current.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
};
const $b0191e7cc5b82c5b$export$d5bb600df302dfc8 = ({ extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, isCompanyHub: isCompanyHub, isInViewMode: isInViewMode })=>{
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $bIp5p.useExtensionsState)();
    const { smartCardProviderComponent: smartCardProviderComponent } = (0, $cfM7x.useProductDependencies)();
    const SmartCardProvider = smartCardProviderComponent || (0, $cozmU.Fragment);
    const [selectedFrameIndex, setSelectedFrameIndex] = (0, $cozmU.useState)(0); // Separately track the index of the hero card that should be scrolled to.
    // This should be in sync with selected frame index above, but this one
    // starts at -1 to prevent scrolling on mount.
    const [scrollToHeroFrameAtIndex, setScrollToHeroFrameAtIndex] = (0, $cozmU.useState)(-1);
    const { cards: frames, cornerStyle: cornerStyle, cornerRadius: cornerRadius, isAutoplayEnabled: isAutoplayEnabled, navigationStyle: navigationStyle } = parameters;
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const theming = (0, $4pBmf.useHubTheming)(); // For gate-ON: resolve per-extension numeric override
    const resolvedCornerRadiusOverride = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined; // Gate ON: derive rounded/squared from the EFFECTIVE corner radius (the local
    // override, else the inherited hub global). The hero border follows
    // `var(--hub-corner-radius)` directly (see SpotlightLayout); this flag is what
    // squares the navigation thumbnails at radius 0. Gate OFF: legacy cornerStyle
    // behaviour.
    const hasRoundedCorners = isCornerRadiusEnabled ? (resolvedCornerRadiusOverride ?? theming?.cornerRadius) !== 0 : cornerStyle === (0, $hjUDQ.CornerStyle).ROUNDED || !isCompanyHub || !cornerStyle;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [width, setWidth] = (0, $cozmU.useState)((0, $aOuIh.VERTICAL_MAX_WIDTH) + 1);
    const frameIds = frames.map((frame)=>frame.cardId);
    const handleSelectFrameAtIndex = (0, $cozmU.useCallback)((requestedIndex)=>{
        setScrollToHeroFrameAtIndex(requestedIndex);
        setSelectedFrameIndex(requestedIndex);
        if (!isInViewMode && extensionLocalId === selectedExtensionLocalId) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(frameIds[requestedIndex]);
        }
    }, [
        setScrollToHeroFrameAtIndex,
        setSelectedFrameIndex,
        frameIds,
        isInViewMode,
        setIsInAutoFocusMode,
        setSelectedToEditCardId,
        extensionLocalId,
        selectedExtensionLocalId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (selectedFrameIndex > frames.length - 1) handleSelectFrameAtIndex(frames.length - 1);
        if (!isInViewMode && selectedToEditCardId) {
            const index = frames.findIndex((card)=>card.cardId === selectedToEditCardId);
            if (index !== -1) handleSelectFrameAtIndex(index);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        frames.length,
        selectedFrameIndex,
        handleSelectFrameAtIndex,
        selectedToEditCardId,
        isInViewMode
    ]);
    const carouselRef = (0, $cozmU.useRef)(null);
    const spotlightHero = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b0191e7cc5b82c5b$var$styles.containerStyles)
    }, frames.map(({ cardId: cardId, backgroundColor: backgroundColor, layout: layout, imageSrc: imageSrc, imageAltText: imageAltText, title: title, description: description, textColor: textColor, link: link, buttonStyle: buttonStyle, buttonText: buttonText }, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Sbqg.CarouselLayoutRenderer), {
            key: cardId,
            index: index,
            frameSetLength: frames.length,
            selectedFrameIndex: scrollToHeroFrameAtIndex,
            extensionLocalId: extensionLocalId,
            testId: `carousel-spotlight-${index}--${index === selectedFrameIndex ? 'active' : 'not-active'}`,
            backgroundColor: backgroundColor,
            height: (0, $hjUDQ.Height).MEDIUM,
            layout: layout,
            imageData: imageSrc,
            imageAltText: imageAltText,
            width: width,
            imageWidthPercentage: $b0191e7cc5b82c5b$var$IMAGE_PERCENTAGE,
            title: title,
            description: description,
            textColor: textColor,
            link: link,
            buttonStyle: buttonStyle,
            buttonText: buttonText,
            contentId: contentId,
            hasRoundedCorners: hasRoundedCorners,
            cornerRadiusOverride: resolvedCornerRadiusOverride,
            source: (0, $gXR7h.carouselContentAnalyticSource)
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
        setWidth: setWidth,
        offscreen: true
    }));
    const handleMouseOrFocusChange = (event)=>{
        if (event === 'enter') setIsHovered(true);
        else setIsHovered(false);
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onMouseEnter: ()=>handleMouseOrFocusChange('enter'),
        onMouseLeave: ()=>handleMouseOrFocusChange('leave'),
        onFocusCapture: ()=>handleMouseOrFocusChange('enter'),
        onBlurCapture: ()=>handleMouseOrFocusChange('leave'),
        ref: carouselRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        wrap: "wrap",
        gap: "space.150",
        testId: "carousel-v2-content-container"
    }, spotlightHero, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58e21593b205ee37$export$6239edc19b7276da), {
        isInViewMode: !!isInViewMode,
        frameIds: frames.map((frame)=>frame.cardId),
        selectedHeroFrameIndex: selectedFrameIndex,
        setSelectedHeroFrameIndex: handleSelectFrameAtIndex,
        extensionLocalId: extensionLocalId,
        isHovered: isHovered,
        isCarouselVisible: ()=>$b0191e7cc5b82c5b$export$daaa732503241aed(carouselRef),
        isAutoplayEnabled: isAutoplayEnabled && isInViewMode,
        navigationStyle: navigationStyle || (0, $4MaGu.NavigationStyle).THUMBNAILS,
        width: width,
        frames: frames.map((frame, index)=>{
            const isSelectedToEdit = selectedToEditCardId === frame.cardId && extensionLocalId === selectedExtensionLocalId;
            const isSelectedToRemove = selectedToRemoveCardId === frame.cardId && extensionLocalId === selectedExtensionLocalId;
            return (0, $ieeJu.expValEquals)('company_hub_carousel_thumbnails-refactor', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c060bae43cf38d9$export$3c072ff478476aa0), {
                contentId: contentId,
                wrapperHeight: 40,
                minWidth: 200,
                maxWidth: 200,
                onSucceeded: ()=>{},
                onFailed: ()=>{},
                isEmpty: !frame.link,
                isSelected: selectedFrameIndex === index,
                hasRoundedCorners: hasRoundedCorners,
                ...frame,
                setSelectedHeroFrameIndex: handleSelectFrameAtIndex,
                index: index,
                isSelectedToEdit: isSelectedToEdit,
                isSelectedToRemove: isSelectedToRemove
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d9744d68c931f1dc$export$d3fc0aff4df25c77), {
                key: frame.cardId,
                itemId: frame.cardId,
                extensionLocalId: extensionLocalId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c060bae43cf38d9$export$3c072ff478476aa0), {
                contentId: contentId,
                wrapperHeight: 40,
                minWidth: 200,
                maxWidth: 200,
                onSucceeded: ()=>{},
                onFailed: ()=>{},
                isEmpty: !frame.link,
                isSelected: selectedFrameIndex === index,
                hasRoundedCorners: hasRoundedCorners,
                ...frame,
                setSelectedHeroFrameIndex: handleSelectFrameAtIndex,
                index: index
            }));
        })
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SmartCardProvider, null, content);
};
module.exports["CarouselContentV2"] = $b0191e7cc5b82c5b$export$d5bb600df302dfc8;

});


//# sourceMappingURL=carousel-extension.c5c62fa6.js.map
